
import { Component, ChangeDetectorRef, inject } from '@angular/core';
import { Auth, authState, signOut, User } from '@angular/fire/auth';

import { Subscription } from 'rxjs';
import { LoginComponent } from "./login/login.component";
import { MainComponent } from "./main/main.component";
import { LoadingSpinnerComponent } from "./loading-spinner/loading-spinner.component";
import { AuthGateService } from "./services/auth-gate.service";

@Component({
    selector: 'app-root',
    imports: [MainComponent, LoginComponent, LoadingSpinnerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent {
  private auth = inject(Auth);
  private cdr = inject(ChangeDetectorRef);
  private authGate = inject(AuthGateService);

  title = 'blazebite-super-admin';
  isLoggedIn?: boolean;
  userName: string = '';
  private authSubscription?: Subscription;

  constructor() {
    const auth = this.auth;

    if (auth) {
      this.authSubscription = authState(auth).subscribe((user: User | null) => {
        this.gateAccess(user);
      });
    }
  }

  // Authentication alone is not access — once signed in, confirm the user is a
  // super-admin via the backend gate; sign out and flag non-super-admins.
  private async gateAccess(user: User | null): Promise<void> {
    if (!user) {
      this.isLoggedIn = false;
      this.userName = '';
      this.cdr.detectChanges();
      return;
    }

    // Show the spinner while we verify, so non-admins never flash the app.
    this.isLoggedIn = undefined;
    this.cdr.detectChanges();

    const allowed = await this.authGate.isSuperAdmin();
    if (allowed) {
      this.authGate.notAuthorized.set(false);
      this.userName = user.displayName || '';
      this.isLoggedIn = true;
      this.cdr.detectChanges();
      return;
    }

    // Not a super-admin: flag it and sign out. signOut re-fires authState(null),
    // which routes back to the login screen where the flag shows the message.
    this.authGate.notAuthorized.set(true);
    await signOut(this.auth);
  }

  ngOnDestroy() {
    this.authSubscription?.unsubscribe();
  }
}
